import ApiUtil from '@/apis/apiutil'
import MutationTypes from './mutation-types'
import { UserIn } from 'rpc/Login/Login'
import { CartSku, UpdateBuyerMallSkuIn } from 'rpc/MisBuyer/MisBuyer'

export default {
  async getConfig ({
    commit,
    state}) {
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      let data = await api.getConfig()
      let config = data['config']
      commit(MutationTypes.SET_CONFIG, config)
      return config
    } catch (error) {
      console.error('getConfig failed: ' + error)
    }
  },
  async getSellerConfig ({
    commit,
    state,
    getters
  }, sellerCompanyid) {
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisCommApi()
      if (getters.isSellerApp && sellerCompanyid === 0) {
        await this.dispatch('getUserInfoAction')
      }
      let data = await api.getSellerCompanyConfig(sellerCompanyid)
      let config = data['config']
      commit(MutationTypes.SET_SELLER_CONFIG, config)
      return config
    } catch (error) {
      console.error('getConfig failed: ' + error)
    }
  },
  async getUserInfoAction ({
    commit,
    state,
    getters}, isForceUpdate = false) {
    let userInfoEx = state.userInfo
    if (userInfoEx.isValid() && !isForceUpdate) {
      return userInfoEx.data
    }
    if (!getters.isLogin) {
      console.log('user is logout')
      return null
    }

    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getLoginApi()
      let data = await api.getUser()
      userInfoEx.data = data.user
      if (state.$uweb) {
        state.$uweb.setCustomVar('m', data.user.mobile, '-1')
      }
      return userInfoEx.data
    } catch (error) {
      console.error('getUser failed: ' + error)
      throw error
    }
  },
  async updateWxOpenid ({
    state
  }) {
    try {
      let userInfo = await this.dispatch('getUserInfoAction')
      if (state.openid && userInfo && userInfo.wx_openid !== state.openid) {
        let apiUtil = new ApiUtil(this)
        let api = apiUtil.getLoginApi()
        let userIn = new UserIn()
        userIn.userid = userInfo.userid
        userIn.wx_openid = state.openid
        await api.updateUser(userIn)
        userInfo.wx_openid = state.openid
      }
    } catch (error) {
      console.error('update wx_openid failed: ' + error)
    }
  },
  async getLastOrderSkuList ({
    state,
    getters,
    commit
  }, userid) {
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisSellerApi()
      let data = await api.getLastOrderSkuList(userid)
      for (let orderSku of data.skuList) {
        let cartSku = new CartSku()
        cartSku.valid = true
        cartSku.skuid = orderSku.skuid
        cartSku.count = orderSku.count
        cartSku.ss_name = orderSku.ss_name
        cartSku.ss_spec = orderSku.ss_spec
        cartSku.ss_img = orderSku.ss_img
        cartSku.ss_price = orderSku.ss_price
        cartSku.seller_companyid = getters.sellerCompanyid
        commit(MutationTypes.UPDATE_SHOPPINGCART, cartSku)
      }
    } catch (error) {
      console.error('getLastOrderSkuList failed: ' + error)
    }
  },
  async getBuyerMallSkuList ({
    commit,
    state,
    getters
  }) {
    if (!getters.isLogin) {
      console.warn('getBuyerMallSkuList not login')
      return
    }
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      let data = await api.getBuyerMallSkuStatusList()
      let customSkuMap = {}
      data.skus.forEach((skuItem) => {
        let skuMap = customSkuMap[skuItem.customid] || {}
        skuMap[skuItem.skuid] = skuItem
        customSkuMap[skuItem.customid] = skuMap
      })
      commit(MutationTypes.SET_SUPPLIER_SKU_MAP, customSkuMap)
    } catch (error) {
      console.error('getBuyerMallSkuList failed: ' + error)
    }
  },
  async updateBuyerMallSku ({
    commit,
    state,
    getters
  }, mallSku, lastCount, isChecked) {
    if (!getters.isLogin) {
      console.warn('updateBuyerMallSku not login')
      return
    }
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      let updateIn = new UpdateBuyerMallSkuIn()
      updateIn.skuid = mallSku.skuid
      updateIn.customid = mallSku.customid
      updateIn.count = mallSku.count
      updateIn.checked = mallSku.checked
      let data = await api.updateBuyerMallSkuStatus(updateIn)
      mallSku = data.msku
      commit(MutationTypes.UPDATE_SUPPLIER_SKU, {[mallSku.customid]: {[mallSku.skuid]: mallSku}})
    } catch (error) {
      console.error('updateBuyerMallSku failed: ' + error)
      mallSku.count = lastCount
      mallSku.checked = isChecked
      commit(MutationTypes.UPDATE_SUPPLIER_SKU, {[mallSku.customid]: {[mallSku.skuid]: mallSku}})
    }
  },
  async clearBuyerMallSkuChecked ({
    commit,
    state,
    getters
  }) {
    if (!getters.isLogin) {
      console.warn('clearBuyerMallSkuChecked not login')
      return
    }

    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisBuyerApi()
      await api.clearBuyerMallSkuStatus()
      commit(MutationTypes.CLEAR_SUPPLIER_SKU_CHECKED)
    } catch (error) {
      console.error('clearBuyerMallSkuChecked failed: ' + error)
    }
  },
  async getSkuSimpleInfoList ({
    commit,
    state
  }, skuPriceIn) {
    try {
      let apiUtil = new ApiUtil(this)
      let api = apiUtil.getMisSellerApi()
      let data = await api.getSkuSimpleInfoList(skuPriceIn)
      commit(MutationTypes.UPDATE_SHOPPINGCAR, data['skuInfoList'])
    } catch (error) {
      console.error('getSkuSimpleInfoList failed: ' + error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/apps/baseapp/store/actions.js